import type { AccountHealth } from "../data/types";

/** 8px status dot. Status colours follow the DS pattern: success / warning / error. */
const TONE: Record<AccountHealth, string> = {
  healthy: "bg-success-500",
  risk: "bg-warning-500",
  critical: "bg-error-500",
};

const LABEL: Record<AccountHealth, string> = {
  healthy: "Healthy",
  risk: "At risk",
  critical: "Critical",
};

export function HealthDot({ health }: { health: AccountHealth }) {
  return (
    <span
      role="img"
      aria-label={LABEL[health]}
      className={`inline-block h-2 w-2 flex-none rounded-full ${TONE[health]}`}
    />
  );
}

const HEALTH_TEXT: Record<AccountHealth, string> = {
  healthy: "text-success-600",
  risk: "text-warning-700",
  critical: "text-error-600",
};

/** Dot plus its word, for tables where health is a column rather than a flag. */
export function HealthBadge({ health }: { health: AccountHealth }) {
  return (
    <span className={`inline-flex items-center gap-2 text-sm font-medium ${HEALTH_TEXT[health]}`}>
      <HealthDot health={health} />
      {LABEL[health]}
    </span>
  );
}

/** Health values with their labels, for select controls. */
export const HEALTH_OPTIONS: { value: AccountHealth; label: string }[] = [
  { value: "healthy", label: "Healthy" },
  { value: "risk", label: "At risk" },
  { value: "critical", label: "Critical" },
];
